import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormControlStateService {

  setControlState(form: FormGroup, controls: string | string[], enable: boolean): void {
    (Array.isArray(controls) ? controls : [controls]).forEach(name => {
      const control = form.get(name);
      if (control) {
        enable ? control.enable() : control.disable();
      } else {
        console.warn(`Control '${name}' no encontrado.`);
      }
    });
  }

}
